import styled from 'styled-components';
import {Form} from 'formik';

export const Wrapper = styled(Form)`
  position: relative;
  justify-content: space-between;
  flex-direction: column;
  display: flex;
`;
